import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable, forkJoin } from "rxjs";
import { filter, map, switchMap, take } from "rxjs/operators";
import { AppvizerUrlService } from "../../../services";
import { AutoCompleteDataMapper, AutoCompleteQueryBuilder } from "../models";

@Injectable()
export class SearchEntityService {

  // Maximum number of entities to get from server - Can be overriden if needed
  limit = "10";

  constructor(
    private readonly http: HttpClient,
    private readonly appvizerUrl: AppvizerUrlService) {
  }

  /*
   * Try to get entites from the server by autocompletion then map them via {@param dataMapper}
   */
  getEntitiesByTyped<K>(
    autocompleteQueryBuilder: AutoCompleteQueryBuilder,
    dataMapper: AutoCompleteDataMapper<K>,
    typed: string
  ): Observable<Array<K>> {
    if (!autocompleteQueryBuilder) {
      throw Error("An autocomplete query builder needs to be given in order to search for entities in server");
    }

    return forkJoin([
      this.appvizerUrl.initialized$.pipe(
        filter(value => value),
        take(1)
      ),
      this.appvizerUrl.getLocaleConfig()
    ],
    ).pipe(
      switchMap(([_, localeConfig]) =>
        this.http.post<any>(this.appvizerUrl.softwareCenterUrl + '/graphql',
          {
            query: autocompleteQueryBuilder(localeConfig.domainId, typed, this.limit)
          }
        )
      ),
      map(res => dataMapper(res.data))
    );
  }
}
